import { SelectValue } from 'elements/minute/sidebar/sidebarComponents/atomic/SelectValue';
import { getCookie, setCookie } from 'libs/utils/logic/operations/storageOperations';
import { useContext, useState } from 'react';
import { CtxApp } from 'session/ctxApp';
import { LOCAL_STORAGE_LANGUAGE } from 'static/config/coreConfig';
import { languages } from 'static/config/language/languageConfig';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ChangeLanguage = (props: Props): JSX.Element => {
    const ctxApp = useContext(CtxApp);
    const [selectedOption, setSelectedOption] = useState<string>(getCookie(LOCAL_STORAGE_LANGUAGE));
    const options = languages.map((e) => ({
        label: e.title,
        value: e.code
    }));

    function changeLanguage(langCode: string): void {
        const lang = languages.find((e) => e.code === langCode);
        if (!lang) {
            return;
        }
        setCookie(LOCAL_STORAGE_LANGUAGE, lang.code);
        Localization.setLanguage(lang.code);
        ctxApp.setLanguage(lang.code);
    }

    return (
        <S_ChangeLanguage className={props.className}>
            <SelectValue
                options={options}
                selectedOption={options.find((e) => e.value === selectedOption)}
                onChange={(selected) => {
                    setSelectedOption(selected.value);
                    changeLanguage(selected.value);
                }}
            />
        </S_ChangeLanguage>
    );
};

const S_ChangeLanguage = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
